/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebfieldfacebook3Inputs */

const en_placewebfieldfacebook3 = /** @type {(inputs: Placewebfieldfacebook3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook`)
};

const de_placewebfieldfacebook3 = /** @type {(inputs: Placewebfieldfacebook3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook`)
};

/**
* | output |
* | --- |
* | "Facebook" |
*
* @param {Placewebfieldfacebook3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebfieldfacebook3 = /** @type {((inputs?: Placewebfieldfacebook3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebfieldfacebook3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebfieldfacebook3(inputs)
	return de_placewebfieldfacebook3(inputs)
});
export { placewebfieldfacebook3 as "placeWebFieldFacebook" }